<div class="onboarding-tips__overlay" [ngClass]="{'onboarding-tips--visible': isVisible}">
  <div
    class="onboarding-tips"
    [ngStyle]="{'top.px': offsetTop, 'right.px': offsetRight}"
    [ngClass]="{'onboarding-tips--offset-top': offsetTop, 'onboarding-tips--offset-right': offsetRight}"
  >
    <div class="onboarding-tips__image" [ngClass]="currentPageKey ? 'onboarding-tips__image--' + currentPageKey : ''"></div>
    <div class="onboarding-tips__content">
      <h2 class="onboarding-tips__title">
        {{ OnboardingTipsConstant[currentPageKey | uppercase]?.title }}
        <ng-container *ngIf="isShowTips">
          <div class="onboarding-tips__number">{{ activeTip + 1 }}</div>
        </ng-container>
      </h2>
      <div
        class="onboarding-tips__desc"
        [innerHtml]="isShowTips ?
        OnboardingTipsConstant[currentPageKey | uppercase]?.tips[activeTip] :
        OnboardingTipsConstant[currentPageKey | uppercase]?.desc "
      ></div>
      <div class="onboarding-tips__buttons">
        <ng-container [ngSwitch]="OnboardingTipsConstant[currentPageKey | uppercase]?.buttons">
          <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="help"></ng-container>
            <ng-container *ngTemplateOutlet="gotIt"></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'dots'">
            <ng-container *ngIf="!isShowTips">
              <ng-container *ngTemplateOutlet="help"></ng-container>
              <button type="button" p500-ui-button class="--protection__button onboarding-tips__button" (click)="showTips()">
                <span i18n="@@common.show_tips">Show Tips</span>
              </button>
            </ng-container>

            <ng-container *ngIf="isShowTips">
              <ul class="onboarding-tips__dots">
                <ng-container *ngFor="let dot of OnboardingTipsConstant[currentPageKey | uppercase]?.tips; index as i">
                  <li
                    class="onboarding-tips__dot"
                    [ngClass]="{'onboarding-tips__dot--active': activeTip === i}"
                    (click)="changeTip(i)"
                  ></li>
                </ng-container>
              </ul>

              <div class="onboarding-tips__controls">
                <button type="button" class="onboarding-tips__back mr-20" i18n="@@common.back" (click)="previousTip()">Back</button>
                <ng-container *ngIf="OnboardingTipsConstant[currentPageKey | uppercase]?.tips.length !== activeTip + 1; else gotIt">
                  <button type="button" p500-ui-button class="--protection__button onboarding-tips__button" (click)="nextTip()">
                    <span i18n="@@common.continue">Continue</span>
                  </button>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #help>
  <a href="https://support.irev.com/en/categories/423106-affiliate-area" target="_blank" class="onboarding-tips__help">
    <span i18n="@@common.help_center">Help Center</span>
    <i class="h-icon p500-ui-icon-chevron-right ml-9"></i>
  </a>
</ng-template>

<ng-template #gotIt>
  <button type="button" p500-ui-button class="--protection__button onboarding-tips__button" (click)="close()">
    <span i18n="@@common.got_it">Got It</span>
  </button>
</ng-template>
